export const TIME_ADD_ENTRY_SUCCESS = 'TIME_ADD_ENTRY_SUCCESS';
export const TIME_ADD_MODAL_SHOW = 'TIME_ADD_MODAL_SHOW';
export const TIME_ID_RATE_TO_EDIT = 'TIME_ID_RATE_TO_EDIT';
export const TIME_RATE_CONFIRM_SUCCESS = 'TIME_RATE_CONFIRM_SUCCESS';
export const TIME_RATE_SET = 'TIME_RATE_SET';
export const TIME_REMOVE = 'TIME_REMOVE';
export const TIME_SET = 'TIME_SET';
export const TIME_TO_EDIT = 'TIME_TO_EDIT';
export const TIME_UPDATE = 'TIME_UPDATE';
